import { useMutation } from 'react-query';

import { changePassword as mutationFn } from 'api/endPoints/changePassword';

export const useMutationChangePassword = () => {
    return useMutation<unknown, QueryError, any>('changePassword', (params) => mutationFn(params));
};
